export const commonTimeZones = [
  // Americas
  `America/New_York`, // Eastern Time (ET) - New York
  `America/Chicago`, // Central Time (CT) - Chicago
  `America/Denver`, // Mountain Time (MT) - Denver
  `America/Los_Angeles`, // Pacific Time (PT) - Los Angeles
  `America/Sao_Paulo`, // São Paulo
  `America/Buenos_Aires`, // Argentina Time (ART) - Buenos Aires
  `America/Toronto`, // Eastern Time (ET) - Toronto
  `America/Vancouver`, // Pacific Time (PT) - Vancouver
  `America/Mexico_City`, // Central Time (CT) - Mexico City
  `America/Edmonton`, // Mountain Time (MT) - Edmonton
  `America/La_Paz`, // Bolivia Time (BOT) - La Paz
  `America/Montevideo`, // Uruguay Standard Time (UYT) - Montevideo
  `America/Puerto_Rico`, // Atlantic Standard Time (AST) - San Juan
  `America/Guatemala`, // Central Time (CT) - Guatemala City
  `America/Caracas`, // Venezuela Time (VET) - Caracas

  // Europe
  `Europe/Lisbon`, // Western European Time (WET) - Lisbon
  `Europe/London`, // Greenwich Mean Time (GMT) - London
  `Europe/Berlin`, // Central European Time (CET) - Berlin
  `Europe/Madrid`, // Central European Time (CET) - Madrid
  `Europe/Paris`, // Central European Time (CET) - Paris
  `Europe/Rome`, // Central European Time (CET) - Rome
  `Europe/Amsterdam`, // Central European Time (CET) - Amsterdam
  `Europe/Brussels`, // Central European Time (CET) - Brussels
  `Europe/Zurich`, // Central European Time (CET) - Zurich
  `Europe/Prague`, // Central European Time (CET) - Prague
  `Europe/Bucharest`, // Eastern European Time (EET) - Bucharest

  // Asia
  `Asia/Tokyo`, // Japan Standard Time (JST) - Tokyo
  `Asia/Shanghai`, // China Standard Time (CST) - Shanghai
  `Asia/Singapore`, // Singapore Time (SGT) - Singapore
  `Asia/Hong_Kong`, // Hong Kong Time (HKT) - Hong Kong
  `Asia/Seoul`, // Korea Standard Time (KST) - Seoul
  `Asia/Bangkok`, // Indochina Time (ICT) - Bangkok
  `Asia/Jakarta`, // Western Indonesia Time (WIB) - Jakarta
  `Asia/Kolkata`, // Indian Standard Time (IST) - Kolkata
  `Asia/Manila`, // Philippine Time (PHT) - Manila
  `Asia/Dubai`, // Gulf Standard Time (GST) - Dubai

  // Australia
  `Australia/Sydney`, // Australian Eastern Standard Time (AEST) - Sydney
  `Australia/Brisbane`, // Australian Eastern Standard Time (AEST) - Brisbane
  `Australia/Adelaide`, // Australian Central Standard Time (ACST) - Adelaide
  `Australia/Perth`, // Australian Western Standard Time (AWST) - Perth

  // Middle East
  `Asia/Istanbul`, // Turkey Time (TRT) - Istanbul
  `Asia/Qatar`, // Arabian Standard Time (AST) - Doha
  `Asia/Kuwait`, // Arabian Standard Time (AST) - Kuwait

  // Africa
  `Africa/Johannesburg`, // South Africa Standard Time (SAST) - Johannesburg
  `Africa/Cairo`, // Eastern European Time (EET) - Cairo
  `Africa/Nairobi`, // East Africa Time (EAT) - Nairobi
  `Africa/Lagos`, // West Africa Time (WAT) - Lagos

  // Additional Locations
  `Asia/Yekaterinburg`, // Yekaterinburg Time (YEKT) - Yekaterinburg
  `Asia/Irkutsk`, // Irkutsk Time (IRKT) - Irkutsk
  `Asia/Vladivostok`, // Vladivostok Time (VLAT) - Vladivostok
  // `Pacific/Auckland`, // New Zealand Time (NZT) - Auckland
  // `Pacific/Fiji`, // Fiji Time (FJT) - Suva
  // `Pacific/Guam`, // Chamorro Standard Time (ChST) - Guam
];
